import React, {useEffect, useState} from "react";
import MyPageAnnounceBoard from "../components/MyPageAnnounceBoard";
import MyPageAttend from "../components/MyPageAttend";
import MyPageCalendar from "../components/MyPageCalendar";
import MyPagePlan from "../components/MyPagePlan";
// import BoardWriteBox from "../components/BoardWriteBox";
import config from "../config/config";
const API_URL = config.API_URL;

function MyPage() {
  // const [isBoardOpen, setIsBoardOpen] = useState(false);
  // const [selectedId, setSelectedId] = useState(null);
  // const [isPlanOpen, setIsPlanOpen] = useState(false);
  const [attendRate, setAttendRate] = useState(0);
  const [attend, setAttend] = useState(0);
  const [loading, setLoading] = useState(false);

  const daysInMonth = getDaysInCurrentMonth();

  // const handleBoardClick = (_id) => {
  //   //상호 배타
  //   setIsPlanOpen(false);

  //   setSelectedId(_id);
  //   setIsBoardOpen(true);
  // }
  // const handleBoardClose = () =>{
  //   setIsBoardOpen(false);
  // }
  // const handlePlanClick = (_id) => {
  //   //상호 배타
  //   setIsBoardOpen(false);

  //   setSelectedId(_id);
  //   setIsPlanOpen(true);
  // }
  // const handlePlanClose = () =>{
  //   setIsPlanOpen(false);
  // }

  // API 호출 함수
  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/commute/getUserMonthlyCommute`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // console.log(result.value);

      if(result.value){
        setAttend(result.value);
        // setAttendRate(Math.floor((result.value / daysInMonth) * 100));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setError(error.message); // 에러 메시지 저장
    } finally {
      setLoading(false); // 데이터 로딩 완료
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div style={styles.main}>
      <div style={styles.topLine}>
        <MyPageAnnounceBoard style={{flex:"6.6"}}/>
        {loading ? (
          <p>Loading...</p>
        ):(
          <MyPageAttend style={{flex:"4"}} attend={attend} total={daysInMonth}/>
        )}
      </div>
      <div style={styles.bottomLine}>
        <MyPageCalendar style={{flex:"2"}}/>
        <MyPagePlan style={{flex:"3.5"}}/>
      </div>     
      {/* {isBoardOpen && (
        <BoardWriteBox boardTypeId={"Announce"} boardTypeName={"공지사항"} onClose={handleBoardClose} boardId={selectedId} edit={false}/>
      )} */}
      {/* {isPlanOpen && (
        <BoardWriteBox boardTypeId={"Plan"} boardTypeName={"일정"} onClose={handlePlanClose} boardId={selectedId} edit={false}/>
      )} */}
    </div>
  );  
}

function getDaysInCurrentMonth(){
  // 현재 한국 시간 가져오기
  const now = new Date();
  const kstOffset = 9 * 60; // KST(UTC+9) offset (분 단위)
  const kstTime = new Date(now.getTime() + kstOffset * 60 * 1000);

  // 현재 연도와 월 구하기
  const year = kstTime.getFullYear();
  const month = kstTime.getMonth() + 1; // 월은 0부터 시작하므로 +1

  // 해당 월의 마지막 날짜 구하기
  const lastDay = new Date(year, month, 0).getDate();
  return lastDay;
}
const styles ={
  main :{
    display: "flex",
    gap: "20px",
    flexDirection: "column",
    flex: "1",
    padding: "16px"
  },
  topLine:{
    display: "flex",
    gap: "20px",
    height: "400px"
  },
  bottomLine:{
    display: "flex",
    flex: "1",
    gap: "20px"
  }
}

export default MyPage;